import * as yup from "yup";

export const pestDiseaseScheama = yup.object().shape({
  diseasesName: yup.string().required("Required"),
  typeOfDiseases: yup.string(),
  image: yup.mixed(),
  description: yup.string(),
  productToUse: yup.string(),
  productPhoto: yup.mixed(),
  productLink: yup.string(),
  usageOfProduct: yup.string(),
  usageOfProductModerate: yup.string(),
  productToUseModerate: yup.string(),
  productPhotoModerate: yup.mixed(),
  productLinkModerate: yup.string(),
  usageOfProductWild: yup.string(),
  productToUseWild: yup.string(),
  productPhotoWild: yup.mixed(),
  productLinkWild: yup.string(),
  usageOfProductOrganic: yup.string(),
  productToUseOrganic: yup.string(),
  productPhotoOrganic: yup.mixed(),
  productLinkOrganic: yup.string(),
});
